import {
  CollctionDataType,
  CollectionMasterDataType,
  CollectionDataCache,
  ItemDataType,
  MasterDataType,
  OwnerData,
  ItemFileData,
} from "../types";
import { BACKEND_URL } from "../config";
import { TelegramInitData } from "@/types/telegram";
import {
  Account,
  ConnectAdditionalRequest,
  TonProofItemReplySuccess,
} from "@tonconnect/sdk";
import { LSService } from "./storage";
import { useTonConnect } from "@/hooks/useTonConnect";

export default abstract class BackendConnect {
  private headers: Record<string, string> = {};

  constructor(headers: Record<string, string>) {
    this.headers = headers;
  }

  protected async get(
    path: string,
    params?: Record<string, string | number | boolean | number[]>
  ): Promise<any> {
    let endpoint = `${BACKEND_URL}${path}`;
    const queryParams = new URLSearchParams();

    // 1. Получаем токен из хранилищ (асинхронно)
    const token = await LSService.getTonAuthToken();

    // 2. Добавляем токен как GET-параметр, если он существует
    if (token) {
      queryParams.append("token", token);
    }

    // 3. Прикрепляем остальные параметры
    if (params) {
      for (const [key, value] of Object.entries(params)) {
        if (value === undefined || value === "undefined") {
          continue;
        }
        if (Array.isArray(value)) {
          value.forEach(item => {
            queryParams.append(`${key}[]`, String(item));
          });
        } else {
          queryParams.append(key, String(value));
        }
      }
    }

    // Собираем финальный URL
    const queryString = queryParams.toString();
    if (queryString) {
      endpoint += `?${queryString}`;
    }

    try {
      const res = await fetch(endpoint, {
        method: "GET",
        headers: new Headers(this.headers), // Не забываем про базовые заголовки
      });
      const json: any = await res.json();
      return json; // Promise resolve происходит автоматически в async методе
    } catch (e: any) {
      console.error("GET request error:", e);
      throw e;
    }
  }

  protected async post<T>(
    path: string,
    body: T | FormData,
    method: "POST" | "PUT" | "PATCH" = "POST"
  ) {
    try {
      const endpoint = `${BACKEND_URL}${path}`;
      // const { recreatePayloadFunction } = useTonConnect();
      const headers: HeadersInit = {
        Accept: "application/json",
      };

      // Only add Content-Type for JSON bodies, not FormData
      if (!(body instanceof FormData)) {
        headers["Content-Type"] = "application/json";
      }
      const token = await LSService.getTonAuthToken();
      // alert(`Token: ${token}`);

      const bodyToSend =
        body instanceof FormData
          ? (() => {
              body.append("token", String(token));
              return body;
            })()
          : { ...body, token }; // , token
      const response = await fetch(endpoint, {
        method: method,
        mode: "cors",
        // credentials: "include",
        body:
          bodyToSend instanceof FormData
            ? bodyToSend
            : JSON.stringify({ ...body, token }),
        headers: new Headers(headers),
      });

      if (!response.ok) {
        const json = await response.json();
        throw new Error(json?.error);
      }

      return await response.json();
    } catch (e: any) {
      throw new Error(e);
    }
  }

  protected setAccessToken(accessToken: string) {
    this.headers.Authorization = `${accessToken}`;
  }
}
